import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { TabHeaderWidthDirective } from './tab-header-width.directive';

@Component({
    selector: 'web-tab-header-width',
    templateUrl: './tab-header-width.component.html',
    styleUrls: ['./tab-header-width.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TabHeaderWidthDirective],
})
export class TabHeaderWidthComponent {
    public readonly widthValue = input.required<number>();
    public readonly widthUnit = input.required<string>();
    public readonly rootElementId = input.required<string>();
    public readonly headerElementId = input.required<string>();
    public readonly bodyElementId = input.required<string>();
    public readonly isRight = input<boolean>(false);

    public readonly widthChange = output<number>();
    public readonly dragStart = output<void>();
    public readonly dragEnd = output<void>();
}
